import { EditCaseDialog } from '@/modules/projects'
import { useDialogActions } from '@/stores/dialog'
import { cn } from '@/utils'

interface EditButtonProps {
  className?: string
  children: React.ReactNode
}

export const CaseEditButton = ({ children, className }: EditButtonProps) => {
  const { openDialog } = useDialogActions()

  return (
    <button
      className={cn('cursor-pointer', className)}
      type="button"
      aria-haspopup="dialog"
      onClick={() => openDialog(EditCaseDialog.id)}
    >
      {children}
    </button>
  )
}
